import { TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CPP } from '../cargoPrioritization.classes';

export default function CargoPrioritizationHeader() {
    const { t } = useTranslation();
    
    const headerData = [
        { title: t('cargoPrioritization.columns.priorityOrder') },
        { title: t('cargoPrioritization.columns.cargoCompany') },
        { title: t('cargoPrioritization.columns.creditCardActivity') },
        { title: t('cargoPrioritization.columns.cashOnDeliveryActivity') },
        { title: t('cargoPrioritization.columns.orderLimit') },
        { title: t('cargoPrioritization.columns.totalOrderCount') },
        { title: t('cargoPrioritization.columns.priorityOrderCount') },
        { title: t('cargoPrioritization.columns.updateDate') },
        { title: t('cargoPrioritization.columns.updatedBy') },
    ];

    return (
        <TableHead className={CPP.tableHead}>
            <TableRow>
                {headerData.map((item, index) => (
                    <TableCell key={index} align="center">
                        {item.title}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
